import request from '@/util/request'


export const roleList = (data) => request.post('/api/roleList', data);  //角色列表

export const roleAdd = (data) => request.post('/api/roleAdd', data);  //角色添加

export const roleEdit = (data) => request.post('/api/roleEdit', data);  //角色编辑

export const roleDetail = (data) => request.post('/api/roleDetail', data);  //角色详情

export const roleStatus = (query) => request.post('/api/roleUpdStatus', query);  //角色启用/禁用